<template>
    <div>
        <link rel="stylesheet" href="/themes/ito/css/upgrade-feature.css">
        <p class="label-upgrade">{{ $t('please_select_how_you_would_like_to_pay') }}:</p>
        <div v-for="(item, index) in products_list" class="slect-product" :key="index">
            <div v-if="item.feature_code === package_select">
                <input :id="'product_' + item.product_id" name="product_item" type="radio" v-model="product" :value="item.product_id" />
                <label :for="'product_' + item.product_id" class="slect-package d-flex justify-content-between box-shadow-main">
                    <div class="slect-name">
                        <p>{{ item.product_name ? item.product_name : 'Product Name' }}</p>
                        <p>{{ item.price | toCommas }} &#8363;</p>
                    </div>
                    <span>{{ item.desc.price_month | toCommas }}{{ $t('month') }}*</span>
                </label>
            </div>
        </div>
        <p><b>(*) {{ $t('note') }}:</b> {{ $t('desc_payment') }}</p>
        <div class="col-md-12 mt-20 text-center">
            <div class="btn btn-back" @click="updateStep(1)"> {{ $t('back') }}</div>
            <div class="btn btn-main" :class="{ 'disabled': product === '' }" @click="product != '' ? updateStep(3) : ''" :aria-disabled="product === ''"> {{ $t('continue_txt') }}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'UpgradeFeatureDetail',
    props: {
        package_select: {
            type: String,
            required: true
        },
        products_list: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            product: ''
        }
    },
    methods: {
        updateStep(step) {
            this.$emit('updateStep', step, this.product, '', '');
        }
    }
}
</script>

<style scoped>
[type="radio"]:not(:checked),
[type="radio"]:checked {
    position: absolute;
    opacity: 0;
    pointer-events: none;
}

.slect-package {
    height: 65px;
    padding: 0 30px;
    align-items: center;
    font-weight: 700;
    font-size: 20px;
    color: #FFFFFF;
    background: #C1C1C1;
    margin-bottom: 12px;
    cursor: pointer;
}

.slect-product [type=radio]:checked+label.slect-package {
    color: #ffffff;
    background: #e98437;
}

.slect-name{
    font-size: 14px;
    font-weight: 400;
    margin-top: 15px;
}

.box-shadow-main {
    border-radius: 8px;
    box-shadow: 4px 4px 0px rgba(0, 0, 0, 0.07), inset 0px 4px 0px rgba(231, 231, 231, 0.25);
}

.btn-back{
    font-size: 20px;
    height: 45px;
    margin-right: 20px;
    line-height: 45px;
    align-items: center;
    width: fit-content;
    line-height: 32px;
}

.btn-undo {
    background: #fff;
    color: #212529;
    width: 120px;
}

.btn-continue {
    width: 180px;
}

.btn-main.disabled {
    opacity: 0.5;
    cursor: not-allowed !important;
}
</style>